import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';
import { UserService } from '../../services/user.service';
import { ImportDialogComponent } from '../import-dialog/import-dialog.component';

export const MY_FORMATS = {
  parse: {
  dateInput: 'DD/MMM/YYYY',
  },
  display: {
  dateInput: 'DD/MMM/YYYY',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMM YYYY',
  },
  };

@Component({
  selector: 'app-event-edit',
  templateUrl: './event-edit.component.html',
  styleUrls: ['./event-edit.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
})
export class EventEditComponent implements OnInit, OnDestroy {
  private user$: Subscription;
  user: any;
  date = new FormControl(moment());

  public quillModules = {
    toolbar: [['bold', 'italic', 'underline'],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ['clean']
    ]    
  }

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EventEditComponent>,   
    public userService: UserService,  
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
    
  }

  ngOnInit(): void {
    // Subscribe to the user and get it
    this.user$ = this.userService.user$.subscribe(data => {           
      if (data != null) {
        this.user = data[0];
      } else {
        this.user = {id:"",username:"",initials:""}
      }
    })
    this.data.row.forEach(item => {
      if(item['name']){
        if(this.data.data.data[item['name']]==undefined){
          this.data.data.data[item['name']] = {id:"",propertyname:item['name'],propertytext:'',newtext:'',accountid:this.data.data.account["id"],versionid:this.data.data.versionid};   
          if(item['label']=="Contributor"){
            this.data.data.data[item['name']].newtext = this.user.username;
          }     
        } else {
          if(this.getType(item)=="date"){
            this.data.data.data[item['name']]['propertytext'] = new Date(this.data.data.data[item['name']]['propertytext']);
            this.data.data.data[item['name']]['newtext'] = this.data.data.data[item['name']]['propertytext'];
          }else{
            this.data.data.data[item['name']]['newtext'] = this.data.data.data[item['name']]['propertytext'];
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.user$.unsubscribe();
  }

  save():void {
    let newdata = {...this.data.data.data};
    let err = false;
    let errMeg = "";
    this.data.row.forEach(item => {
      if(item.isRequired){
        if(this.data.data.data[item['name']]['newtext']==""||!this.data.data.data[item['name']]['newtext']){
          err = true;
          errMeg = errMeg + (item["label"]?item["label"]:item["name"])+" is required.<br>"
        }
      }
    });
    if(err){
      const importDialogRef = this.dialog.open(ImportDialogComponent, {
        width: '350px',
        data: {title:"Prompt", text: errMeg, loading:false}
      });
      importDialogRef.afterClosed().subscribe(result => {
        
      })
    }else{
      this.dialogRef.close(newdata);
    }
  }

  close(){
    this.dialogRef.close("cancel");
  }

  getType(item){
    if(item["type"]=="dropdown") {
      return "dropdown"
    } else if(item["type"]=="formattedtext") {
      return "formattedtext"
    } else if(item["type"]=="break") {
      return "break"
    } else if(item["type"]=="header") {
      return "header"
    } else if(item["type"]=="table") {
      return "table"
    } else if(item["type"]=="label") {
      return "label"
    } else if(item["type"]=="date") {
      return "date"
    }    
    else {
      return "string"
    }
  }

  editorInit(quill: any){
    quill.clipboard.addMatcher(Node.ELEMENT_NODE, function(node, delta){
      delta.forEach(e => {
        // remove any funny no length spaces
        if(e["insert"] && typeof e["insert"] == "string"){
          e["insert"] = e["insert"].replace(/[\u200B-\u200D\uFEFF]/g,'')
        }
        
        // remove any color properties
        if(e.attributes){
          e.attributes.color = '';
          e.attributes.background = '';
        }
      });
      return delta;
    });
  }
}
